module.exports = __webpack_public_path__ + "static/media/o5.d42c43cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/origami/o5.jpg
// module id = 349
// module chunks = 0